'use client';

import { c as _c } from "react/compiler-runtime";
import { useTransition } from 'react';
import { Arbeidsforhold } from './Arbeidsforhold';
import { Arbeidssted } from './Arbeidssted';
import { Hovedenhet } from './Hovedenhet';
import { store } from '@/app/_components/store/store';
import useAutoScrollToTop from '@/utils/useAutoScrollToTop';
import { useViewHistory } from '@/utils/useViewHistory';
export default function ArbeidsgiverClient() {
  const $ = _c(7);
  const view = store.useReducerState().arbeidsgiver.view;
  const {
    SET_ARBEIDSGIVER_VIEW
  } = store.useActions();
  const [, startTransition] = useTransition();
  let t0;
  if ($[0] !== view) {
    t0 = [view];
    $[0] = view;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  useAutoScrollToTop(t0);
  useViewHistory(view, "hovedenhet", SET_ARBEIDSGIVER_VIEW);
  if (view === "arbeidsforhold") {
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <Arbeidsforhold />;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    return t1;
  }
  if (view === "arbeidssted") {
    let t1;
    if ($[3] !== startTransition) {
      t1 = <Arbeidssted startTransition={startTransition} />;
      $[3] = startTransition;
      $[4] = t1;
    } else {
      t1 = $[4];
    }
    return t1;
  }
  if (view === "hovedenhet") {
    let t1;
    if ($[5] !== startTransition) {
      t1 = <Hovedenhet startTransition={startTransition} />;
      $[5] = startTransition;
      $[6] = t1;
    } else {
      t1 = $[6];
    }
    return t1;
  }
}